import PropTypes from 'prop-types';
import React from 'react';
import addTabnabbing from '../../utils/addTabnabbing';
import slugify from '../../utils/slugify';

export default function AboutUsBlock({ information, team, content }) {
	const mainTeam = team.map((member, key) => (
		// eslint-disable-next-line react/no-array-index-key
		<div className="about-us__main__team__member" key={key + 1}>
			<p className="title">{member.teamMemberTitle.toUpperCase()}</p>
			<p className="fullname">{member.teamMemberFullname}</p>
			<p className="email">
				<a
					className="email-link"
					href={`mailto:${member.teamMemberEmail}`}
					target="_blank"
					rel="noopener noreferrer"
				>
					{member.teamMemberEmail}
				</a>
			</p>
		</div>
	));

	const mainContent = content.map((item) => {
		const title = item.contentTitle;
		const description = addTabnabbing(item.contentDescription);

		return (
			<React.Fragment key={slugify(title)}>
				<div className="about-us__main__content_item">
					<p className="title">{title}</p>
					{description}
				</div>
			</React.Fragment>
		);
	});

	return (
		<div className="about-us">
			<div className="about-us__header">
				<img
					src="/images/about-us.svg"
					alt="We Hope You&apos;re Hungry"
					className="about-us__image"
					aria-label="We Hope You&apos;re Hungry"
				/>
			</div>
			<div className="about-us__main__information_team">
				<div className="information">
					{addTabnabbing(information)}
				</div>
				<div className="team">
					<h2 className="team-title">Meet the Team</h2>
					<div className="team-content">
						{mainTeam}
					</div>
				</div>
			</div>
			<div className="about-us__main__content">
				{mainContent}
			</div>
		</div>
	);
}

AboutUsBlock.propTypes = {
	information: PropTypes.string.isRequired,
	team: PropTypes.array.isRequired,
	content: PropTypes.array.isRequired,
};
